import { createContext } from 'react';
import type { User, Session } from '@supabase/supabase-js';

export interface Organization {
  id: string;
  name: string;
  slug: string | null;
  owner_id: string;
  role: string; // user's role in this org
}

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  loading: boolean;
  signOut: () => Promise<void>;
  organizations: Organization[];
  currentOrganization: Organization | null;
  switchOrganization: (orgId: string) => void;
  refreshOrganizations: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
